import {LiveDashboard} from "@common/ui-components/live/live-dashboard/live-dashboard";
import collection from "./other-colors-collection.json";
import data from "./other-colors-data.json";

export const OtherColorsThemeAuto = (props) => {
    return LiveDashboard({
        collection,
        defaultData: data,
        disabledTileActions: true,
        ...props,
    });
};
